import { connect } from 'react-redux';

import { getLocationSelector } from 'reducers/router';
import type { RootState } from 'reducers';

import QueryStringParams from './query-string-params';

export const mapStateToProps = (state: RootState) => {
  const location = getLocationSelector(state);
  return {
    location,
  };
};

export default connect(mapStateToProps)(QueryStringParams);
